<template>
  <div>
    <Head title="Create UIDs" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-orange-400 hover:text-orange-600" href="/sku-items/">SKU Items</Link>
      <span class="text-orange-400 font-medium">/</span> Sorting/Create/UIDs
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.quantity" :error="form.errors.quantity"
            class="pb-8 pr-6 w-1/2 lg:w-1/2"
            label="Pieces"
            placeholder="Pieces"
          />
          <div class="pb-8 pr-6 w w-1/2 lg:w-1/2">
            <p class="mb-2">SKU:</p>
            <multiselect
              id="part_number"
              v-model="form.sku_id"
              placeholder="Search SKU"
              :options="skus"
              :close-on-select="true"
              :searchable="true"
              :error="form.errors.sku_id"
              :style="form.errors.sku_id ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
            />
            <div v-if="form.errors.sku_id" class="form-error">{{ form.errors.sku_id }}</div>
          </div>
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-orange" type="submit">Generate UIDs</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import Multiselect from '@vueform/multiselect'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
    Multiselect,
  },
  layout: Layout,
  props: {
    skus: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        quantity: null,
        sku_id: '',
      }),
    }
  },
  methods: {
    store() {
      this.msgSuccess = ''
      this.form.post('/sortings/uids/store', {
        onSuccess: () => {
          this.form.reset('quantity', 'sku_id');
          window.location.href = '/item-downloads';
        },
      })
    },
  },
}
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style type="text/css">
  .multiselect-option.is-selected.is-pointed {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
  .multiselect-option.is-selected {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
</style>
